export const SIDEBAR_NAME = 'statistics';

export const AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
export const AUTO_OPEN_SIDEBAR_VALUE = 'statistics';

export const SELECTED_FIELD_ID_KEY = 'selected-field-id';
export const SELECTED_CHART_TYPE_KEY = 'selected-chart-type';

export const CLEAR_ALL_QUERY_PARAMS = Object.freeze({
	[AUTO_OPEN_SIDEBAR_KEY]: undefined,
	[SELECTED_FIELD_ID_KEY]: undefined,
	[SELECTED_CHART_TYPE_KEY]: undefined,
});
